import React, { useState } from "react";
import { useGetResultDetails } from "../../../hooks/resultsHooks/results.hooks";
import { getValue } from "../../../utils/object.utils";
import { KeyValueList } from "../../KeyValueList";
import { Card } from "../../card";
import { formatDateBasedOnTimezone } from "../../../utils/date.utils";
import { Colors } from "../../../Constants/colors";
import { BtnSize, BtnType, Button } from "../../Button";
import { EditResultModal } from "../EditResultModal";
import { GRID_SPACE, GridWrapper } from "../../GridWrapper/GridWrapper";

interface Props {
  resultId: number;
}

export const ResultDetailsCard = ({ resultId }: Props) => {
  const [openEditModal, setOpenEditModal] = useState(false);

  const { isLoading: isResultDetailLoading, data: resultDetails } =
    useGetResultDetails({ resultId });

  if (isResultDetailLoading) return <div></div>;

  const label = getValue(resultDetails, "label", "");
  const code = getValue(resultDetails, "code", "");
  const branchName = getValue(resultDetails, "school_branch_name", "");
  const className = getValue(resultDetails, "class_name", "");
  const publishDate = getValue(resultDetails, "publish_date");
  const totalStudents = getValue(resultDetails, "total_students", "");
  const totalPendingResults = getValue(
    resultDetails,
    "peding_results_count",
    ""
  );
  const formattedPublishDate = publishDate
    ? formatDateBasedOnTimezone({
        date: publishDate,
      })
    : "N/A";

  return (
    <Card cardTitle={label}>
      <GridWrapper
        totalColumns={4}
        gridSpace={GRID_SPACE.sm}
        childrens={[
          {
            component: (
              <KeyValueList
                lists={[
                  { key: "Code", value: code },
                  { key: "Branch", value: branchName },
                  { key: "Class", value: className },
                ]}
              />
            ),
            gridSpan: 1,
          },
          {
            component: (
              <KeyValueList
                lists={[
                  { key: "Publish date", value: formattedPublishDate },
                  { key: "Total students", value: totalStudents },
                  {
                    key: "Total pending results",
                    value: totalPendingResults,
                    listStyle: { color: Colors.BurgundyRed },
                  },
                ]}
              />
            ),
            gridSpan: 1,
          },
          {
            component: (
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  text={"Edit result"}
                  btnType={BtnType.primary}
                  btnSize={BtnSize.md}
                  onClick={() => {
                    setOpenEditModal(true);
                  }}
                />
              </div>
            ),
            gridSpan: 2,
          },
        ]}
      />

      <EditResultModal
        resultDetail={{
          label,
          code,
          publishDate,
          branchId: getValue(resultDetails, "school_branch_id"),
          classId: getValue(resultDetails, "class_id"),
        }}
        onClose={() => {
          setOpenEditModal(false);
        }}
        open={openEditModal}
      />
    </Card>
  );
};
